import * as getFetch from '../fetch/get.js'
import * as store from '../data/store.js'
import * as entropy from '../data/entropy.js'
import * as routerUtilities from '../utilities/router.js'
import * as dateParametersUI from './date-parameters.js'
import * as ui from '../ui.js'
import { format } from 'date-fns'
import { formatDateOnly } from '../utilities/dates.js'

export let refreshDateInterval

export async function checkLastRefreshDate(){
	const currentDate = store.getDataRefreshDate()
	const appArea = routerUtilities.getAppArea()
	const lastDataRefreshDate = await entropy.getLastRefreshDate()
	
	if(currentDate < lastDataRefreshDate){
		let reloadFunction = function(){}
		
		if(appArea == 'reports'){
			reloadFunction = function(){
				const reportForm = document.getElementById('js-form--report')
				dateParametersUI.initializeReportDates(reportForm)
			}
		}
		
		displayReloadDateConfirmation(lastDataRefreshDate, function(){}, reloadFunction)
	}
}

export function resetRefreshDateInterval(){
	clearInterval(refreshDateInterval)
	const intervalTime = 15 * 60 * 1000
	refreshDateInterval = setInterval(checkLastRefreshDate.bind(this), intervalTime)
}

export function displayReloadDateConfirmation(lastDataRefreshDate, cancelFunction, reloadFunction){
	const line1 = "Reload the page to include data through <span class=\"font-bold\">" + format(lastDataRefreshDate, 'MM/dd/yyyy') + "</span>."
	const line2 = "Cancel to view with current data."
	const header = "Data for new date(s) is available"
	const reloadIcon = '<svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>'
	const reloadText = reloadIcon + "Reload"
	
	const cancelFunctionMod = function(){
		resetRefreshDateInterval()
		cancelFunction.apply(null, arguments)
	}
	
	const reloadFunctionMod = async function(){
    	ui.removeReport()
    	
		store.setDataRefreshDate(lastDataRefreshDate)
		ui.displayLastDataRefreshDate(formatDateOnly(lastDataRefreshDate, 'MM/dd/yyyy'))
		
		const reportSelections = await entropy.getReportSelections()
		store.setReportSelections(reportSelections)
		ui.showHideReports(reportSelections)
		
		resetRefreshDateInterval()
		reloadFunction.apply(null, arguments)
	}

	ui.displayConfirmation(header, line1, line2, "Cancel", cancelFunctionMod, reloadText, reloadFunctionMod)
}